import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Loader from "../child/Loder";
import SuccessAlert from "../child/Alert/SuccessAlert";
import DengerAlert from "../child/Alert/DengerAlert";
import { handleUnauthorized } from "../../utils/apiHelper";
import { fetchFeatureRequestById, updateFeatureRequest } from "../services/featureRequest";

const EditFeatureRequestPage = () => {
    const { id } = useParams();
    const navigate = useNavigate();

    const [formData, setFormData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [errorMessage, setErrorMessage] = useState("");
    const [successMessage, setSuccessMessage] = useState("");
    const [errors, setErrors] = useState({});

    const authToken = localStorage.getItem("authToken");

    useEffect(() => {
        fetchRequest();
        // eslint-disable-next-line
    }, [id]);

    const fetchRequest = async () => {
        setLoading(true);
        try {
            const { data } = await fetchFeatureRequestById(id);
            setFormData(data?.data);
        } catch (err) {
            if (err.response?.status === 401) {
                handleUnauthorized(navigate);
                return;
            }
            setErrorMessage(err.response?.data?.message || err.message);
            setTimeout(() => setErrorMessage(""), 3000);
        } finally {
            setLoading(false);
        }
    };

    const validateTitle = (title) => {
        if (!title || !title.trim()) return "Title is required";
        return "";
    };

    const validateDescription = (description) => {
        if (!description || !description.trim()) return "Description is required";
        return "";
    };
    const validateAppVersion = (value) => {
        if (!value || !value.trim()) return "App version is required";

        // Optional: semantic version check (1.0.0, 2.3, 3.0.2 etc.)
        const versionRegex = /^\d+(\.\d+){0,2}$/;
        if (!versionRegex.test(value.trim()))
            return "Enter a valid version (e.g. 1.0 or 1.2.3)";

        return "";
    };

    const validateRequired = (value, label) => {
        if (!value || !value.toString().trim()) {
            return `${label} is required`;
        }
        return "";
    };
    const handleChange = (e) => {
        const { name, value } = e.target;

        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));

        setErrors((prev) => ({
            ...prev,
            [name]:
                name === "title"
                    ? validateTitle(value)
                    : name === "description"
                        ? validateDescription(value)
                        : name === "platform"
                            ? validateRequired(value, "Platform")
                            : name === "appVersion"
                                    ? validateAppVersion(value)
                                    : prev[name],
        }));
    };


    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!formData) return;

        const titleError = validateTitle(formData.title);
        const descError = validateDescription(formData.description);
        const platformError = validateRequired(formData.platform, "Platform");
        const appVersionError = validateAppVersion(formData.appVersion);

        setErrors({
            title: titleError,
            description: descError,
            platform: platformError,
            appVersion: appVersionError,
        });

        if (
            titleError ||
            descError ||
            platformError ||
            appVersionError
        ) {
            return;
        }

        try {
            setLoading(true);

            await updateFeatureRequest(id, {
                title: formData.title,
                description: formData.description,
                platform: formData.platform,
                appVersion: formData.appVersion,
                internalNote: formData.internalNote || "",
            });

            setSuccessMessage("Feature request updated successfully");

            setTimeout(() => {
                navigate("/feature-requests");
            }, 1500);
        } catch (err) {
            if (err.response?.status === 401) {
                handleUnauthorized(navigate);
                return;
            }

            setErrorMessage(err.response?.data?.message || err.message);
            setTimeout(() => setErrorMessage(""), 3000);
        } finally {
            setLoading(false);
        }
    };




    if (loading || !formData) return <Loader />;

    return (
        <div className="row gy-4">
            <div className="col-lg-12">
                <div className="card">
                    <div className="card-body">
                        {successMessage && <SuccessAlert message={successMessage} onClose={() => setSuccessMessage("")} />}
                        {errorMessage && <DengerAlert message={errorMessage} onClose={() => setErrorMessage("")} />}

                        <form onSubmit={handleSubmit} className="row gy-3">
                            <div className="col-md-6">
                                <label className="form-label">Title</label>
                                <input
                                    type="text"
                                    name="title"
                                    placeholder="Enter Title"
                                    className={`form-control ${errors.title ? "is-invalid" : ""}`}
                                    value={formData.title || ""}
                                    onChange={handleChange}
                                    onInput={(e) => {
                                        e.target.value = e.target.value
                                            .replace(/\s{2,}/g, " ")
                                            .trimStart();
                                    }}
                                />
                                {errors.title && <div className="text-danger mt-1">{errors.title}</div>}
                            </div>

                            <div className="col-md-12">
                                <label className="form-label">Description</label>
                                <textarea
                                    name="description"
                                    placeholder="Enter Description"
                                    className={`form-control ${errors.description ? "is-invalid" : ""}`}
                                    value={formData.description || ""}
                                    onChange={handleChange}
                                    rows={4}
                                    onInput={(e) => {
                                        e.target.value = e.target.value
                                            .replace(/\s{2,}/g, " ")
                                            .trimStart();
                                    }}
                                />
                                {errors.description && <div className="text-danger mt-1">{errors.description}</div>}
                            </div>

                            <div className="col-md-6">
                                <label className="form-label">Platform</label>
                                <select
                                    name="platform"
                                    className={`form-select ${errors.platform ? "is-invalid" : ""}`}
                                    value={formData.platform || ""}
                                    onChange={handleChange}
                                >
                                    <option value="" disabled>Select Platform</option>
                                    <option value="web">Web</option>
                                    <option value="ios">iOS</option>
                                    <option value="android">Android</option>
                                </select>
                                {errors.platform && (
                                    <div className="invalid-feedback">{errors.platform}</div>
                                )}

                            </div>

                            <div className="col-md-6">
                                <label className="form-label">App Version</label>
                                <input
                                    type="text"
                                    name="appVersion"
                                    className={`form-control ${errors.appVersion ? "is-invalid" : ""}`}
                                    placeholder="Enter App Version"
                                    value={formData.appVersion || ""}
                                    onChange={handleChange}
                                    onInput={(e) => {
                                        e.target.value = e.target.value
                                            .replace(/\s{2,}/g, " ")
                                            .trimStart();
                                    }}
                                />
                                {errors.appVersion && (
                                    <div className="invalid-feedback">{errors.appVersion}</div>
                                )}
                            </div>

                            <div className="col-md-12">
                                <label className="form-label">Internal note (staff only)</label>
                                <textarea
                                    name="internalNote"
                                    className="form-control"
                                    rows={3}
                                    maxLength={2000}
                                    placeholder="Why, who owns it, what it depends on."
                                    value={formData.internalNote || ""}
                                    onChange={handleChange}
                                />
                                <div className="text-secondary-light text-sm mt-1">
                                    To change the status, use Decide on the list. This page edits the text.
                                </div>
                            </div>

                            <div className="col-md-6">
                                <label className="form-label">Requested By</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={formData.userId?.email || ""}
                                    disabled
                                />
                            </div>
                            <div className="col-12">
                                <button
                                    className="btn btn-primary  mt-3 float-end"
                                    type="submit"
                                    disabled={loading}
                                >
                                    {loading ? "Saving..." : "Save Changes"}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EditFeatureRequestPage;
